import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { finalize } from 'rxjs/operators';
import { EXAM_TYPES } from 'src/app/helpers/examTypes.helper';
import { BenefitTrackerDisplay } from 'src/app/models/benefit-tracker-display.model';
import { Exams } from 'src/app/models/exams.model';
import { Prescription } from 'src/app/models/prescription.model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { BenefitService } from 'src/app/services/repositories/benefits.service';
import { ExamsService } from 'src/app/services/repositories/exams.service';
import { PrescriptionService } from 'src/app/services/repositories/prescription.service';
import { ExamServiceModalComponent } from 'src/app/ui-widgets/modals/exam-service-modal/exam-service-modal.component';

@Component({
    selector: 'app-benefits',
    templateUrl: './benefits.component.html',
    styleUrls: ['./benefits.component.scss'],
    standalone: false
})
export class BenefitsComponent implements OnInit {

  toggle: boolean = true;
  toggleClass: boolean = true;
  btn: boolean = false;
  hearingExam!: Exams;
  visionExam!: Exams;
  submitted = false;
  benefits: BenefitTrackerDisplay[] | undefined;
  employeeID: number | undefined;
  benefitView: boolean[] = [];
  btnClick: boolean[] = [];
  prescription: Prescription | undefined;
  hasRecommendations = false;

  constructor(
    private _benefitService: BenefitService,
    private _loaderService: NgxUiLoaderService,
    private _authService: AuthenticationService,
    private _rxService: PrescriptionService,
    private _examService: ExamsService,
    private _modalService: NgbModal

  ) { }

  ngOnInit(): void {
    this.loadBenefitTracker();
    this.loadExams();
  }

  showExam(event: Exams) {
    const examModalRef = this._modalService.open(ExamServiceModalComponent,
      { modalDialogClass: '', scrollable: true, backdrop: 'static' });
    examModalRef.componentInstance.selectedExam = event;
  }

  toggleActive(): void {
    this.btn = !this.btn;
  }

  toggleBenefitView(index: number): void {
    this.benefitView[index] = !this.benefitView[index];
  }

  toggleA(index: number): void {
    this.btnClick[index] = !this.btnClick[index];
  }

  loadExams() {
    this._examService.getExamsByEmployee(this._authService.getUserId())
      .subscribe((data: Exams[]) => {
        const hear = data.find(e => e.examType == EXAM_TYPES.Hearing);
        if (hear != undefined) {

          this.hearingExam = hear;
        }

        const vision = data.find(e => e.examType == EXAM_TYPES.Vision);
        if (vision != undefined) {
          this.visionExam = vision;
        }
      })
  }

  loadBenefitTracker() {
    this._loaderService.start();
    this._benefitService.getBenefitTracker()
      .pipe(
        finalize(() =>
          this._loaderService.stop()))
      .subscribe((data: BenefitTrackerDisplay[]) => {
        this.benefits = data;
        this.getRecommendations(data);
      }, (error) => {
        console.log(error);
        // this._notificationService.error('An error occurred, please try again', 'Load Employee\'s Contact');
      });
  }


  private getRecommendations(benefits: BenefitTrackerDisplay[]) {
    benefits.forEach((benefit: BenefitTrackerDisplay) => {
      if (benefit.category.includes('Glasses') || benefit.category.includes('Respirator')) {
        this.getPrescription();
        this.hasRecommendations = true;
        /*
          TODO: we return to avoid looping through all
          the items since we are providing recommendations
          for glasses only. When we will have more recos,
          we'll need a differen approach.
        */
        return;
      }
    });
  }

  private getPrescription() {
    this._rxService.getRx()
      .subscribe((data) => {
        this.prescription = data;
      })
  }

}

